import { render, staticRenderFns } from "./UpdateWADAClassification.vue?vue&type=template&id=35a85bb0&scoped=true&"
import script from "./UpdateWADAClassification.vue?vue&type=script&lang=js&"
export * from "./UpdateWADAClassification.vue?vue&type=script&lang=js&"
import style0 from "./UpdateWADAClassification.vue?vue&type=style&index=0&id=35a85bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a85bb0",
  null
  
)

export default component.exports